import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import SessionProxy from '@/Proxies/SessionProxy';
import AllSessionsProxy from '@/Proxies/AllSessionsProxy';

const mapStateToProps = (state, ownProps) => {
  const {
    _session: { session_proxy: sessions },
  } = state.restricted;
  const { allSessionIds } = ownProps;
  return {
    allSessions: allSessionIds.map(id => sessions[id]).filter(s => s),
  };
};

export default function(ContainedComponent) {
  class AllSessionsSubHOC extends Component {
    static propTypes = {
      allSessionIds: PropTypes.array.isRequired,
    };

    componentDidMount() {
      const { allSessionIds = [] } = this.props;
      this.sessionProxySubscription = SessionProxy.subscribe(allSessionIds);
      this.allSessionProxySubscription = AllSessionsProxy.subscribe();
    }

    componentDidUpdate() {
      const { allSessionIds = [] } = this.props;
      this.sessionProxySubscription.update(allSessionIds);
    }

    componentWillUnmount() {
      this.sessionProxySubscription.unsubscribe();
      this.sessionProxySubscription = null;

      this.allSessionProxySubscription.unsubscribe();
      this.allSessionProxySubscription = null;
    }

    render() {
      return <ContainedComponent {...this.props} />;
    }
  }

  return connect(
    mapStateToProps,
    null
  )(AllSessionsSubHOC);
}



// WEBPACK FOOTER //
// ./src/subscribeHOCs/allSessions.js